<template>
  <div class="main" id="main">
      <div class="headerBox">
      <div class="listTit">
        <span class="ranking">排名</span>
        <span class="name">靶位</span>
        <span class="name">姓名</span>
        <span class="org van-hairline--left">单位</span>
        <span class="totalScore van-hairline--left">成绩</span>
      </div>
    </div>
    <div class="matchList">
      <van-list finished>
        <van-cell
          v-for="(item,n) in showData.value"
          :key="n"
          :title="item"
        >
          <div class="matchName" :class="item.remark">
            <div  class="borderBox van-hairline--bottom" :class="{'orgName':item.lane==''||item.merge==1}">
              <span class="ranking">{{item.ranking}}</span>
              <span class="name" ><sapn v-show="item.lane!=''&&item.merge!=1">{{item.lane}}</sapn></span>
              <span class="name" ><sapn v-show="item.lane!=''&&item.merge!=1">{{item.playerName}}</sapn></span>
              <span class="org">
                <sapn v-if="item.lane==''||item.merge==1">{{item.org}}</sapn>
                <div v-else>
                  <p v-for="(data,n) in state.projectInfo.tableHeaderShow" :key="n">
                    {{item.stageScores.length>n?item.stageScores[n].score:''}}
                  </p>
                  
                </div>
                </span>
              <span class="totalScore">{{item.totalScore}}</span>
            </div>
          </div>
        </van-cell>
      </van-list>
    </div>
  </div>
</template>

<script>
import { ref, computed, reactive, toRefs,onMounted } from "vue";
import Paho from "../../common/js/mqtt.js";
import { useRouter } from "vue-router";
import { createState } from "../../store";
var opt;
export default {
  setup(props,{refs,root}) {
    const data = reactive(createState)
    const tableHeaderShow = data.projectInfo.tableHeaderShow
    return {
      state: reactive(createState),
    };
  },
  props: {  //指定接收的值，必须指定类型
    showData: Object
  },
  methods: {
    
  },
  mounted() {
  },
};
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.headerBox {
  width: 100%;
  height: 1rem;
  position: fixed;
    background: #fff;
    z-index: 2;
    border-bottom: 1px solid #333;
  .title{
    background: #39a9ed;
    height: 1rem;
    width: 100%;
    display: block;
    /deep/.van-ellipsis{
      color: #fff;
      max-width: 80%;
      font-size: 0.4rem;
    }
  }
  .listTit{
    width: 96%;
    padding: 0 2%;
    height: 1rem;
    background: #fff;
    text-align: center;
    font-size: 0.4rem;
    font-weight: 700;
    line-height: 1rem;
    border-top: 1px solid #333;
  }
}
.oddcolor{
  background: #FFFFCC;
}
.ranking{
  display: block;
  width: 13%;
  height: 100%;
  float: left;
  line-height: 1rem;
}
.name{
  display: block;
  width: 15%;
  height: 100%;
  float: left;
  line-height: 1rem;
}
.orgName{
    background: #6699CC;
    color: #fff;
}
.org{
  display: block;
  width: 35%;
  height: 100%;
  float: left;
  line-height: 1rem;
  div{
    width: 100%;
    height: 100%;
    display: flex;
    p{
      flex: 1;
    }
  }
  
}
.totalScore{
  display: block;
  width: 20%;
  height: 100%;
  float: left;
  line-height: 1rem;
}
.QF{
  background-color: red;
  color: #fff;
}
.matchList {
  margin-top: 1rem;
  flex: 1;
  height: auto;
  width: 100%;
  background: #fff;
  .van-list {
    width: 100%;
    height: 100%;
    .matchName {
      font-weight: 700;
      width: 100%;
      height: 1rem;
      text-align: left;
      line-height: 1rem;
      font-size: 0.3rem;
      text-align: center;
      .borderBox {
        width: 96%;
        height: 1rem;
        padding: 0 2%;
        overflow: hidden;
        // border-bottom: 1px solid #666;
      }
      .icon {
        width: 0.2rem;
        height: 1rem;
        line-height: 1rem;
        float: left;
      }
    }
  }
}
</style>